import React from 'react';
import '../style/AboutUsStyles.css';

function AboutUs() {
    return (
        <div className="about-container">
            <div className="about-content">
                <div className="about-text">
                    <h2>About Queen's Nails & Spa</h2>
                    <p>We are commited to delivering services that promote health, comfort, and protect your personal style year round. 
                    We have combined exclusive services, the best techniques and products with skillful professional to usher your level of relaxation and vitality beyond this world.
                    At our family salon, all our tools are implements and sealed with 100% sterilized in autoclave. 
                    Be confident when you or your guest get services at QUeens Nails & Spa. We'll make sure your visit exceed your expectations!
                    </p>
                    
                </div>
                <div className="about-stats">
                    <div className="stat-item">
                        <h3>10+</h3>
                        <p>Years of Experience</p>
                    </div>
                    <div className="stat-item">
                        <h3>1000+</h3>
                        <p>Happy Clients</p>
                    </div>
                    <div className="stat-item">
                        <h3>50+</h3>
                        <p>Nail Designs</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AboutUs;
